import React, { memo, useState } from 'react';
import { ListItem, ListItemText, Box, Select, MenuItem } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import FormControl from '@mui/material/FormControl';
import TooltipHelpButton from '../../buttons/TooltipHelpButton/TooltipHelpButton';
import { randomString } from '../../../utilities/randomUtilities';
import WarningButton from '../../buttons/WarningButton';

const styles = theme => ({
    select: {
        fontSize: 14,
        fontWeight: 500,
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&:focus': {
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
    }
});

const SelectListItem = memo(({
    classes,
    value,
    text,
    onChange,
    children,
    options = [],
    toolTip,
    warning,
    disabled,
    actionIconButton,
    MenuProps
}) => {
    const [labelId] = useState(() => `select-label-${randomString()}`);

    return (
        <ListItem>
            <ListItemText>
                {text}
                {toolTip && <TooltipHelpButton title={toolTip} />}
                {warning && <WarningButton title={warning} />}
            </ListItemText>
            <Box display="flex" alignItems="center">
                <FormControl variant="standard">
                    <Select
                        value={value}
                        onChange={onChange}
                        displayEmpty
                        className={classes.select}
                        labelId={labelId}
                        disabled={disabled}
                        MenuProps={MenuProps}
                    >
                        {children}
                        {options.map((option) => (
                            <MenuItem
                                value={option.value}
                                key={option.value}
                                dense
                                disabled={option.disabled}
                                style={{ fontFamily: option.font || 'inherit', ...option.style }}
                            >
                                {option.text}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {actionIconButton}
            </Box>
        </ListItem>
    );
});

export default withStyles(SelectListItem, styles);